import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

export function LoaderPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <CircularProgress />
      <Typography mt={2} variant="body1">
        Loading...
      </Typography>
    </Box>
  )
}
